import type { MouseEvent } from 'react'
import { ArrowLeft } from 'lucide-react'
import { Link, useLocation, useNavigate, type LinkProps } from 'react-router-dom'

function isWorkOrderList(path: unknown): path is string {
  return typeof path === 'string' && /^\/(work-orders|calendar)(\?|$)/.test(path)
}

export function WorkOrderLink({ workOrderId, ...props }: Omit<LinkProps, 'to' | 'state'> & { workOrderId: string }) {
  const location = useLocation()
  const origin = `${location.pathname}${location.search}`
  return <Link {...props} to={`/work-orders/${workOrderId}`} state={isWorkOrderList(origin) ? { workOrderOrigin: origin } : undefined} />
}

export function WorkOrderBackLink() {
  const location = useLocation()
  const navigate = useNavigate()
  const state: unknown = location.state
  const origin = state && typeof state === 'object' && 'workOrderOrigin' in state ? state.workOrderOrigin : null
  const returnTo = isWorkOrderList(origin) ? origin : '/work-orders'

  function returnToList(event: MouseEvent<HTMLAnchorElement>) {
    if (!isWorkOrderList(origin) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    event.preventDefault()
    navigate(-1)
  }

  return <Link className="back-link" to={returnTo} onClick={returnToList}><ArrowLeft size={17} aria-hidden="true" />{returnTo.startsWith('/calendar') ? 'Календарь работ' : 'Мои задания'}</Link>
}
